module.exports = __webpack_public_path__ + "media/application/images/investors-55805c0d982bca4a105ec7cf2283c497.jpg";